import { FC } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import { PhotoConfig } from "../../../domain/event.interface";

interface PhotoConfigSectionProps {
	photoConfig: PhotoConfig;
	onChange: (config: PhotoConfig) => void;
	errors?: Record<string, string>;
}

export const PhotoConfigSection: FC<PhotoConfigSectionProps> = ({
	photoConfig,
	onChange,
	errors,
}) => {
	return (
		<Grid item xs={12}>
			<Box
				sx={{
					border: 1,
					borderColor: "divider",
					borderRadius: 1,
					p: 2,
					mt: 1,
				}}
			>
				<Typography variant="subtitle1" sx={{ mb: 2 }}>
					Photo Configuration
				</Typography>

				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}>
						<TextField
							fullWidth
							type="number"
							label="Min Photos"
							value={photoConfig.minPhotos}
							onChange={(e) =>
								onChange({
									...photoConfig,
									minPhotos: Math.max(1, parseInt(e.target.value) || 1),
								})
							}
							inputProps={{ min: 1, max: 20 }}
							error={!!errors?.minPhotos}
							helperText={errors?.minPhotos}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<TextField
							fullWidth
							type="number"
							label="Max Photos"
							value={photoConfig.maxPhotos}
							onChange={(e) =>
								onChange({
									...photoConfig,
									maxPhotos: Math.max(1, parseInt(e.target.value) || 1),
								})
							}
							inputProps={{ min: 1, max: 20 }}
							error={!!errors?.maxPhotos}
							helperText={errors?.maxPhotos}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<FormControlLabel
							control={
								<Switch
									checked={photoConfig.sequentialCapture || false}
									onChange={(e) =>
										onChange({
											...photoConfig,
											sequentialCapture: e.target.checked,
										})
									}
								/>
							}
							label="Sequential Capture"
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<FormControlLabel
							control={
								<Switch
									checked={photoConfig.allowRetake || false}
									onChange={(e) =>
										onChange({
											...photoConfig,
											allowRetake: e.target.checked,
										})
									}
								/>
							}
							label="Allow Retake"
						/>
					</Grid>
				</Grid>
			</Box>
		</Grid>
	);
};
